import React, { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
import padlockIcon from "../assets/icons/padlock.svg";
import logoSmall from "../assets/images/logoSmallGrey.svg";
import EnableTwoFA from "./EnableTwoFA";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import TwoFA from "./MainTwoFA";
import withOverlay from "../hoc/withOverlay";
import CurrencyFormatter from "../utils/currencyFormatter";

const TwoFAOverlay = withOverlay(TwoFA);
export default function DonationConfirmation({
  onBack,
  onConfirm,
  setUp,
  customQuote,
  asset,
  orgName,
}) {
  const [open, setOpen] = useState(false);
  const [isTwoFAOpen, setIsTwoFAOpen] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const { settings } = useAuth();

  useEffect(() => {
    setIsEnabled(settings?.security?.twoFactorAuth?.enabled);
  }, [settings]);
  const handleLocalBack = () => {
    onBack?.();
  };
  const handleTwoFA = () => {
    if (!isEnabled) {
      setOpen(true);
    }
    if (isEnabled) {
      onConfirm();
    }
  };
  const handleSetUp = () => {
    if (setUp) {
      setUp();
    }
  };
  const formatter = new CurrencyFormatter();
  return (
    <>
      <div className="flex justify-center mt-12 px-4 md:px-16 lg:px-32">
        <div className="max-w-3xl w-full">
          <Card className="bg-white rounded-2xl shadow-sm overflow-hidden">
            <CardHeader className="px-9 pt-6 pb-4">
              <CardTitle className="text-2xl font-semibold text-text-secondary text-[20px]">
                <div className="flex items-center">
                  <div>Review your donation</div>
                </div>
              </CardTitle>
            </CardHeader>

            <CardContent className="px-9 pt-2  pb-6">
              <div className="columns-1 mb-6">
                <div className="relative w-full border-[1px] rounded-[12px] border-bg-border ">
                  <div className="flex justify-between border-b-[1px] border-bg-border rounded-t-[12px] w-full  focus:ring-2 focus:ring-purple-400 transition bg-white px-5 py-5">
                    <p className=" text-[14px] font-normal ">You Donate</p>
                    <p className=" text-[14px] font-semibold text-text-primary ">
                      {formatter.format(
                        customQuote?.amount,
                        asset?.asset?.toUpperCase()
                      )}
                    </p>
                  </div>
                  <div className="flex justify-between text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-white text-[14px] font-normal px-5 py-5">
                    <p className=" text-[14px] font-normal ">Pay with</p>
                    <p className=" text-[14px] font-semibold text-text-primary ">
                      {asset?.asset?.toUpperCase()}
                    </p>
                  </div>
                  <div className="flex justify-between text-sm border-t-[1px] border-bg-border  w-full  focus:ring-2 focus:ring-purple-400 transition bg-white text-[14px] font-normal px-5 py-5">
                    <p className=" text-[14px] font-normal ">Donate to</p>
                    <p className=" text-[14px] font-semibold text-text-primary ">
                      {orgName}
                    </p>
                  </div>
                  <div className="flex justify-between border-t-[1px] border-bg-border rounded-b-[12px] text-sm  w-full  focus:ring-2 focus:ring-purple-400 transition bg-white text-[14px] font-normal px-5 py-5">
                    <p className=" text-[14px] font-normal ">Pay from</p>
                    <p className=" text-[14px] font-semibold text-text-primary ">
                      Digital Wallet
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex justify-center py-3">
                <Button
                  variant="ghost"
                  onClick={handleLocalBack}
                  className="w-10 h-10 mr-10 rounded-full p-0 flex items-center justify-center border border-gray-200 hover:bg-gray-100"
                >
                  <ArrowLeft size={20} className="text-gray-700" />
                </Button>
                <Button
                  className="bg-gradient-to-r from-purple-500 to-pink-500 text-white py-2 rounded-full w-[40%]"
                  onClick={handleTwoFA}
                >
                  Continue
                </Button>
                <EnableTwoFA
                  open={open}
                  setOpen={setOpen}
                  setIsTwoFAOpen={setIsTwoFAOpen}
                />
              </div>
              <TwoFAOverlay
                isOpen={isTwoFAOpen}
                closeOverlay={() => setIsTwoFAOpen(false)}
                isSetUp={handleSetUp}
              />
            </CardContent>
            <Separator />
            <div className="py-4 text-[14px] text-text-secondary font-normal">
              <div className="flex justify-center items-center">
                <img src={padlockIcon} className="mr-1" alt="" />
                <p>Secured by</p>
                <img src={logoSmall} className="ml-1" alt="" />
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
